export default __webpack_public_path__ + "static/media/boardTop.min.037b91f6.png";